import React from 'react';
import { useCart } from '../../contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import './CartPage.css';

function CartPage() {
  const { items, getCartTotal, removeFromCart, updateQuantity, clearCart } = useCart();
  const navigate = useNavigate();

  // Where "Continue Shopping" should take the user — defaults to /shop,
  // but if they arrived here straight from a product/event page we send them back there.
  let continueShoppingHref = '/shop';
  try {
    const stored = sessionStorage.getItem('lastShoppingPath');
    if (stored && stored !== '/cart' && stored !== '/checkout') {
      continueShoppingHref = stored;
    }
  } catch (_) {}

  const handleQuantityChange = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId);
    } else {
      updateQuantity(productId, newQuantity);
    }
  };

  const handleClearCart = () => {
    if (window.confirm('Are you sure you want to clear your basket?')) {
      clearCart();
    }
  };

  /* Member pricing disabled for now — uncomment when membership program is active
  const { isMember, getMemberPrice } = useAuth();
  const getDiscountedTotal = () => { ... };
  const getTotalSavings = () => { ... };
  */

  return (
    <div className="cart-page">
      <div className="cart-container">
        <h1>SHOPPING BASKET</h1>

        {items.length === 0 ? (
          <div className="empty-cart">
            <h2>Your basket is empty</h2>
            <p>Browse our shop to add items to your basket.</p>
            <a href={continueShoppingHref} className="continue-shopping-btn">Continue Shopping</a>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {items.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="item-details">
                    <h3>{item.name}</h3>
                    <p className="item-category">{item.category}</p>
                    <div className="item-price">
                      <span>{item.price} SEK</span>
                    </div>
                  </div>

                  {item.variant === 'download' ? (
                  <div className="quantity-section">
                    <label>Digital download</label>
                  </div>
                  ) : (
                  <div className="quantity-section">
                    <label>Quantity:</label>
                    <div className="quantity-controls">
                      <button
                        className="qty-btn"
                        onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                      >
                        -
                      </button>
                      <span className="quantity">{item.quantity}</span>
                      <button
                        className="qty-btn"
                        onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  )}

                  <div className="item-total">
                    <p><strong>{(item.price * item.quantity).toFixed(2)} SEK</strong></p>
                  </div>

                  <button
                    className="remove-btn"
                    onClick={() => removeFromCart(item.id)}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <div className="cart-actions">
                <button className="clear-cart-btn" onClick={handleClearCart}>
                  Clear Basket
                </button>
                <a href={continueShoppingHref} className="continue-shopping-btn">
                  Continue Shopping
                </a>
              </div>

              <div className="cart-total">
                <h2>Total: {getCartTotal().toFixed(2)} SEK</h2>
                <button
                  className="checkout-btn"
                  onClick={() => navigate('/checkout')}
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CartPage;
